var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEyeEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1141,
    height: 790,
    viewBox: "0 0 1141 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M570.215 511.746C634.799 511.746 687.151 459.394 687.151 394.81C687.151 330.226 634.799 277.873 570.215 277.873C505.631 277.873 453.278 330.226 453.278 394.81C453.278 459.394 505.631 511.746 570.215 511.746Z",
    stroke: "black",
    strokeWidth: 87.7024,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.43 394.81C986.006 569.688 787.617 745.619 570.215 745.619C352.812 745.619 154.421 569.688 44 394.81C178.392 228.657 335.852 44 570.215 44C804.579 44 962.04 228.655 1096.43 394.81Z",
    stroke: "black",
    strokeWidth: 87.7024,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeEmpty);
export default __webpack_public_path__ + "static/media/icon_eye_empty.f848514e361312a1f66045a2b6d7ff1e.svg";
export { ForwardRef as ReactComponent };